import Axios from "axios";
import {
    SET_PUR_RECEIVE_REPORT,
    UNSET_PUR_RECEIVE_REPORT,
} from "@/store/mutation-types";
import { getPurReceiveReport } from "@/store/api";

const state = {
    getPurReceiveReport: [],
};

const getters = {
    getPurReceiveReport(state) {
        return state.getPurReceiveReport;
    },
};

const mutations = {
    [SET_PUR_RECEIVE_REPORT](state, data) {
        state.getPurReceiveReport = data;
    },
    [UNSET_PUR_RECEIVE_REPORT](state) {
        state.getPurReceiveReport = [];
    },
};

const actions = {
    getPurReceiveReport({ commit }, params) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getPurReceiveReport, { params })
                .then((response) => {
                    commit(SET_PUR_RECEIVE_REPORT, response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_RECEIVE_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


